import React, { useEffect } from "react";
import { Router, Switch } from "react-router-dom";
import RouteComponent from "./route-config.jsx";
import { UrlCollection } from "./common/url-collection";
import history from "./common/history";

//--- Loading
import AppLoading from "./components/loading/loading.view";

//--- Layout
import LayoutView from "./components/layout/layout.view";
import LayoutUserView from "./components/layout/layout-user.view.jsx";
import LayoutRemoteSensing from "./modules/remote-sensing/layout-remote-sensing/layout-remote-sensing.view.jsx"
import NoLayout from "./components/layout/no-layout.view.jsx";

//--- Home
import Home from "./modules/home/home.view.jsx";

//--- Admin
import Login from "./modules/login/login.view.jsx";
import LoginFromMobile from "./modules/login/login-from-mobile.view.jsx";
import ForgotPassword from "./modules/forgot-password/forgot-password.view.jsx";
import ResetPassword from "./modules/reset-password/reset-password.view.jsx";

//--- Consult the community
import EmailTemplate from "./modules/email-template/email-template";
import RoleManagement from "./modules/role-management/role-management";
import ContactManagement from "./modules/contact-management/contact-management.view";
import EmailGenerated from "./modules/email-generated/email-generated.view";
import UserManagement from "./modules/user-management/user-management.view";
import CommuneManagement from "./modules/communce-management/communce-management.view";
import StreetManagement from "./modules/street-management/communce-management.view";
import UnitManagement from "./modules/unit-management/communce-management.view";
import ProviceManagement from "./modules/province-management/provice-management.view";
import DistrictManagement from "./modules/district-management/district-management.view";
import UserLogHistory from "./modules/user-log/user-log-history.view";
import LandTypeManagement from "./modules/land-type-management/land-type-management.view";
import LandTypeDetailManagement from "./modules/land-type-detail-management/land-type-detail-management.view";
import PlaceManagement from "./modules/place-management/place-management.view.jsx";
import PlaceTypeManagement from "./modules/place-type-management/place-type-management.view.jsx";
import PlaceKindManagement from "./modules/place-kind-management/place-kind-management.view.jsx";
//--- Slider
import Slider from "./modules/slider/slider.view.jsx";

//--- News
import News from "./modules/news/news.view.jsx";

//--- Map
import MapData from "./modules/map-data/map-data.view.jsx";
import InitMapDataView from "./modules/init-map-data/init-map-data";

//--- Records management
import RecordsManagement from "./modules/planning-announcement-process/records-management/records-management.view.jsx";
//--- Link
import LinkGroupManagementView from "./modules/link-group/link-group-management.view.jsx";
import ServiceLinkManagementView from "./modules/service-links/service-link-management.view";

//--- Opinion form
import OpinionForm from "./modules/opinion-form/opinion-form.view.jsx";

//--- Table Layer Structure
import TableStructure from "./modules/table-structure/table-structure.view.jsx";

//--- remote sensing
import MapRemoteSensing from "./modules/remote-sensing/map-remote-sensing/map-remote-sensing.view.jsx";
import HistoryRemoteSensing from "./modules/remote-sensing/history-remote-sensing/history-remote-sensing.view.jsx";
import InfoTableRemoteSensing from "./modules/remote-sensing/infomation-table-remote-sensing/infomation-table-remote-sensing.view.jsx";
import PhotoGalleryRemoteSensing from "./modules/remote-sensing/photo-gallery-remote-sensing/photo-gallery-remote-sensing.view.jsx";
import RemoteSensingManagement from "./modules/remote-sensing/remote-sensing-management/remote-sensing-management.view.jsx";
import RemoteSensingPending from "./modules/remote-sensing/remote-sensing-management/pending/pending.view.jsx";
import RemoteSensingManage from "./modules/remote-sensing/remote-sensing-management/list-remote-sensing/list-remote-sensing.view.jsx";

//--- Access denied
import AccessDenied from "./modules/access-denied/access-denied.view.jsx";

import DocumentManagement from "./modules/document-management/document-management.view.jsx";
import LandUsePLanningManagement from "./modules/planning-announcement-process/records-management/land-use-management.view.jsx";
import TrafficPlanningManagement from "./modules/planning-announcement-process/records-management/traffic-planning-management.view.jsx";
import { getMessagingToken, onMessageListener } from "./firebase.ts";
import ShowNotifications from "./components/show-notifications/show-notifications.view.jsx";
import ProjectManagement from "./modules/project-management/project-management.view.jsx";
import MapProjectManagement from "./modules/project-management/map-project-management.view.jsx";
import { getUserInfo } from "./utils/configuration.js";
import { isMobile } from "react-device-detect";

function App() {
  const user = getUserInfo();

  useEffect(() => {
    getMessagingToken();
    // const channel = new BroadcastChannel("notifications");
    // channel.addEventListener("message", (event) => {
    //   console.log("Receive background: ", event.data);
    // });
  }, [])

  // useEffect(() => {
  //   onMessageListener().then(data => {
  //     console.log("Receive foreground: ", data)
  //   })
  // })

  return (
    <div>
      <ShowNotifications />
      <AppLoading />
      <Router history={history}>
        <Switch>
          <RouteComponent exact layout={LayoutUserView} component={LoginFromMobile} path={UrlCollection.LoginFromMobile} />
          <RouteComponent exact layout={LayoutUserView} component={Login} path={UrlCollection.Login} />
          <RouteComponent exact layout={LayoutUserView} component={ForgotPassword} path={UrlCollection.ForgotPassword} />
          <RouteComponent exact layout={LayoutUserView} component={ResetPassword} path={UrlCollection.ResetPassword} />

          <RouteComponent exact layout={NoLayout} component={Home} path={UrlCollection.Home} />
          {/* <RouteComponent exact layout={LayoutView} component={ConstructionInvestmentProjectManagement} path={UrlCollection.ConstructionInvestmentProjectManagement} /> */}
          <RouteComponent exact layout={LayoutView} component={RecordsManagement} path={UrlCollection.Home} />
          <RouteComponent exact layout={LayoutView} component={ProjectManagement} path={UrlCollection.ProjectManagement} />
          <RouteComponent exact layout={LayoutView} component={MapProjectManagement} path={UrlCollection.MapProjectManagement} />
          <RouteComponent exact layout={LayoutView} component={LandUsePLanningManagement} path={UrlCollection.LandUsePLanningManagement} />
          <RouteComponent exact layout={LayoutView} component={TrafficPlanningManagement} path={UrlCollection.TrafficPlanningManagement} />
          {/* Slider */}
          <RouteComponent exact layout={LayoutView} component={Slider} path={UrlCollection.Slider} />

          {/* News */}
          <RouteComponent exact layout={LayoutView} component={News} path={UrlCollection.News} />

          {/* Planning Announcement Process */}
          <RouteComponent exact layout={LayoutView} component={RecordsManagement} path={UrlCollection.PlanningAnnouncementProcess} />

          {/* Map */}
          <RouteComponent exact layout={LayoutView} component={MapData} path={UrlCollection.MapData} />
          <RouteComponent exact layout={LayoutUserView} component={InitMapDataView} path={UrlCollection.CreateMapData} />

          {/* Email Template */}
          <RouteComponent exact layout={LayoutView} component={EmailTemplate} path={UrlCollection.EmailTemplate} />

          {/*Email Generated */}
          <RouteComponent exact layout={LayoutView} component={EmailGenerated} path={UrlCollection.EmailGenerated} />

          {/* Role Management */}
          <RouteComponent exact layout={LayoutView} component={RoleManagement} path={UrlCollection.RoleManagement} />

          {/* Contact Management */}
          <RouteComponent exact layout={LayoutView} component={ContactManagement} path={UrlCollection.ContactManagement} />

          {/* User Management */}
          <RouteComponent exact layout={LayoutView} component={UserManagement} path={UrlCollection.UserManagement} />

          {/* commune Management */}
          <RouteComponent exact layout={LayoutView} component={CommuneManagement} path={UrlCollection.CommuneManagement} />

          {/* Street Management */}
          <RouteComponent exact layout={LayoutView} component={StreetManagement} path={UrlCollection.StreetManagement} />

          {/* Street Management */}
          <RouteComponent exact layout={LayoutView} component={UnitManagement} path={UrlCollection.UnitManagement} />

          {/* District Management */}
          <RouteComponent exact layout={LayoutView} component={DistrictManagement} path={UrlCollection.DistrictManagement} />

          {/* Province Management */}
          <RouteComponent exact layout={LayoutView} component={ProviceManagement} path={UrlCollection.ProvinceManagement} />

          {/* Link Group Management */}
          <RouteComponent exact layout={LayoutView} component={LinkGroupManagementView} path={UrlCollection.LinkGroup} />

          {/* Service Link Management */}
          <RouteComponent exact layout={LayoutView} component={ServiceLinkManagementView} path={UrlCollection.ServiceLink} />
          {/* User log */}
          <RouteComponent exact layout={LayoutView} component={UserLogHistory} path={UrlCollection.UserLogHistory} />

          {/* Opinion Form */}
          <RouteComponent exact layout={LayoutView} component={OpinionForm} path={UrlCollection.OpinionForm} />

          {/* Land Type */}
          <RouteComponent exact layout={LayoutView} component={LandTypeManagement} path={UrlCollection.LandType} />


          {/* Land Detail Type */}
          <RouteComponent exact layout={LayoutView} component={LandTypeDetailManagement} path={UrlCollection.LandTypeDetail} />

          {/* Place */}
          <RouteComponent exact layout={LayoutView} component={PlaceManagement} path={UrlCollection.Place} />

          {/* Place Type */}
          <RouteComponent exact layout={LayoutView} component={PlaceTypeManagement} path={UrlCollection.PlaceType} />

          {/* Place Kind */}
          <RouteComponent exact layout={LayoutView} component={PlaceKindManagement} path={UrlCollection.PlaceKind} />

          {/* Table Layer Structure */}
          <RouteComponent exact layout={LayoutView} component={TableStructure} path={UrlCollection.TableStructure} />
          {/* Access Denied */}
          <RouteComponent exact layout={LayoutView} component={AccessDenied} path={UrlCollection.AccessDenied} />
          <RouteComponent exact layout={LayoutView} component={DocumentManagement} path={UrlCollection.DocumentManagement} />
          {/* remote sensing */}
          <RouteComponent exact layout={LayoutRemoteSensing} component={MapRemoteSensing} path={UrlCollection.MapRemoteSensing} />
          <RouteComponent exact layout={LayoutRemoteSensing} component={PhotoGalleryRemoteSensing} path={UrlCollection.PhotoGalleryRemoteSensing} />
          <RouteComponent exact layout={LayoutRemoteSensing} component={InfoTableRemoteSensing} path={UrlCollection.InfomationTableRemoteSensing} />
          <RouteComponent exact layout={LayoutRemoteSensing} component={HistoryRemoteSensing} path={UrlCollection.HistoryRemoteSensing} />
          <RouteComponent exact layout={LayoutRemoteSensing} component={RemoteSensingManagement} path={UrlCollection.RemoteSensingManagement} />
          <RouteComponent exact layout={LayoutRemoteSensing} component={RemoteSensingPending} path={UrlCollection.RemoteSensingPending} />
          <RouteComponent exact layout={LayoutRemoteSensing} component={RemoteSensingManage} path={UrlCollection.RemoteSensingList} />
        </Switch>
      </Router>

    </div>
  );
}

export default App;
